import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

/**
 * TODO: Probably it would be correct to rename selector to `selectPartnerType` and rename store key
 * */
export const selectPartnerAccess = createSelector(
  [selectPartner360Data],
  ({ partnerAccess }) => partnerAccess
)
